module.exports = __webpack_public_path__ + "static/media/commercial.cc9c66f3.svg";